import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5da81b4e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "@/assets/fonts/materialdesignicons/materialdesignicons.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/style.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports